var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"units-switch"},_vm._l((_vm.options),function(unit){return _c('button',{key:unit.id,class:{
			'is-active': _vm.active === unit.id
		},on:{"click":function($event){_vm.$emit('change', unit.id)}}},[_vm._v("\n\t\t"+_vm._s(unit.text)+"\n\t")])}))}
var staticRenderFns = []

export { render, staticRenderFns }